/* Renders shape data from draw.ts as React SVG elements. */

import { createElement, Fragment, ReactElement } from 'react';
import type { Shape } from '../draw';

/** stroke-width -> strokeWidth, class -> className; data-* and aria-* stay as written. */
const propName = (attr: string) => {
  if (attr === 'class') return 'className';
  if (attr.startsWith('data-') || attr.startsWith('aria-')) return attr;
  return attr.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
};

function toElement(shape: Shape, key: number): ReactElement {
  const props: Record<string, string | number> = { key };
  Object.entries(shape.attrs).forEach(([k, v]) => {
    if (v !== undefined) props[propName(k)] = v;
  });
  return createElement(shape.tag, props, shape.children ? shape.children.map(toElement) : shape.text);
}

export default function KohdShapes({ shapes }: { shapes: Shape[] }) {
  return createElement(Fragment, null, shapes.map(toElement));
}
